(function (){
	angular.module('questionProgress', [

	]);
})();

(function (){
	angular.module('sectionSummary', [

	]);
})();

(function (){
	angular.module('question.couple', [

	]);
})();

(function (){
	angular.module('question.dragList', [

	]);
})();

(function (){
	angular.module('question.multiple', [

	]);
})();

(function (){
	angular.module('question.radioGroup', [

	]);
})();

(function (){
	angular.module('question.selectExtra', [

	]);
})();

(function (){
	angular.module('reusable.status', [

	]);
})();

(function () {

'use strict';

// Declare app level module which depends on views, and components
var app = angular.module('idea', [
  'ngRoute',
  'ngSanitize',
  'ngreally',
  'ngCookies',
  'angular.vertilize',
  'cgBusy',
  'answers',
  'readMore',
  'randomservice',
  'cfp.hotkeys',
  'idea.upload',
  'ngFileUpload',
  'progressbar',
  'imgvisible',
  'ptool',
  'LocalStorageModule',
  'idea.storage',
  'toaster',
  'xeditable',
  'customFilters',
  'ui.grid',
  'ImageService',
  'pascalprecht.translate',
  'i18n',
  'dndLists',
  'question.dragList',
  'question.multiple',
  'question.couple',
  'question.selectExtra',
  'question.radioGroup',
  'idea.login',
  'idea.main',
  'idea.tool_detail',
  'idea.question',
  'idea.logout',
  'idea.services',
  'idea.show_image',
  'idea.help',
  'idea.section_instructions',
  'idea.section_example',
  'idea.summary',
  'idea.connect',
  'sectionSummary',
  'timerservice',
  'questionProgress',
  'countdown',
  'reusable.status',
  'version'
]).
config(['$routeProvider', function($routeProvider) {

	$routeProvider.when('/default',{
		template: "",
		controller: function(Storage, $location){
			Storage.isUserLogged()? $location.path('/main') : $location.path('/login');
		}
	})
	.otherwise('/default');

}]);

//X-editable
app.run(function(editableOptions) {
  editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs2', 'default'
});


//Redirect to login per user non loggato, setting di alcune variabili "globali"
app.run(['$rootScope', '$location', 'Storage', function($rootScope, $location, Storage){

	//Pagine esterne per cui non bisogna fare il redirect alla form di login
	var externalPages = ['/connect'];

	$rootScope.$on('$routeChangeStart', function(event, next, current){
		if(!Storage.isUserLogged()){
			if(!_.contains(externalPages, $location.path())){
				$location.path('/login');
			}
		}else{
			$rootScope.logged = true;
			var user = Storage.getUser();
			$rootScope.userId  = user.id;
			$rootScope.username  = user.username;
			$rootScope.code  = user.code;
			$rootScope.total_periods  = user.total_periods;
			$rootScope.admin = Storage.isUserAdmin();
		}
	});
}]);

app.config(function($httpProvider){
	$httpProvider.interceptors.push('AuthHttpInterceptor');
	$httpProvider.interceptors.push('ResponseLogging');
});

app.config(function($provide, $httpProvider){
	$provide.factory('ResponseLogging', function($q, $injector, $window, $rootScope){
		return {
			response: function(response){
				if(new RegExp("api").test(response.config.url)) {
					console.group("Logging interceptor");
					console.log("Response del server");
					console.dir(response.data);
					console.groupEnd();
				}
				return response  || $q.when(response);
			}
		}});
});
app.config(function($provide, $httpProvider){
	$provide.factory('AuthHttpInterceptor', function($q, $injector, $window, $rootScope, Storage){
		return{
			request: function(config){
				if(new RegExp("api").test(config.url)) {
					if(config.data !== null && !angular.isUndefined(config.data))
						{
							console.groupCollapsed("Auth interceptor");
							console.dir(config.data);

							var user = Storage.getUser();
							console.log("User data:");
							console.dir(user);
							console.groupEnd();

							if(user !== null) {
								config.data.
id=user.id;
								config.data.code=user.code;
							}
						}
				}
				return config || $q.when(config);
			},
		}});
});
//
//Angular-busy configuration
angular.module('idea').value('cgBusyDefaults',{
  message:'Caricamento dati in corso',
  templateUrl: 'app/templates/loading.html',
  backdrop:false
});


})();

'use strict';

angular.module('idea.connect', ['ngRoute'])

        .config(['$routeProvider', function ($routeProvider) {
                $routeProvider.when('/connect', {
			templateUrl: 'app/connect/connect.html',
                    controller: 'connectCtrl'
                });
            }])

.controller('connectCtrl', ['$location', '$rootScope', '$routeParams', '$scope', '$window', 'Storage', 'UserService', function($location, $rootScope, $routeParams, $scope, $window, Storage, UserService) {

	$scope.id = $routeParams.id;
	$scope.code = $routeParams.code;
	$scope.redirecturl = $routeParams.redirecturl;

	Storage.clear();

	UserService.Connect.save({id: $scope.id, code: $scope.code}).$promise
	.then(function(r){

		if(r.valid){
			Storage.saveUser(r);
			Storage.saveRedirectUrl($scope.redirecturl);
			$location.path("/main");
		}else{
			$window.location.replace(createRedirectUrl($scope.redirecturl, r.error));
		}
	});


	function createRedirectUrl(url, error){
		return url + '?error=' + '"' + error + '"';
	}
}]);

'use strict';

angular.module('idea.help', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
	$routeProvider.when('/help', {
		templateUrl: 'app/help/help.html',
		controller: 'helpCtrl'
	});
}])

.controller('helpCtrl', ['$location', '$scope', 'Storage', function ($location, $scope, Storage) {


}]);

'use strict';

angular.module('idea.login', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
  $routeProvider.when('/login', {
    templateUrl: 'app/login/login.html',
    controller: 'loginCtrl'
  });
}])

.controller('loginCtrl', ['$location', '$routeParams', '$scope', 'Storage', 'UserService', 'toaster', function($location, $routeParams, $scope, Storage, UserService, toaster) {

	$scope.abilitazione = $routeParams.abilitazione;

	$scope.login = function(){
		console.log("Funzione enter");
		UserService.Login.save({username: $scope.username, password: $scope.password}, function(data){
			console.dir(data);
			if (data.valid){
				//Ok possiamo entrare
				Storage.saveUser(data);
				$location.path("/main");
			}else{
				//Non possiamo entrare
				toaster.pop('error',"Errore", "Email o password errati", 3000, 'trustedHtml');
			}
		});
	}

}]);

'use strict';

angular.module('idea.logout', ['ngRoute'])

        .config(['$routeProvider', function ($routeProvider) {
                $routeProvider.when('/logout', {
                    templateUrl: 'app/logout/logout.html',
                    controller: 'logoutCtrl'
                });
            }])
.controller('logoutCtrl', ['$interval', '$location', '$rootScope', '$scope', '$window', 'Storage', 'UserService', 'toaster', function($interval, $location, $rootScope, $scope, $window, Storage, UserService, toaster) {

	var redirectUrl = Storage.getRedirectUrl();

	if(_.isNull(redirectUrl) || _.isUndefined(redirectUrl)){
		logoutUser();
		$location.path("/logout");
	}else{
		logoutUser();
		$window.location.href = redirectUrl;
	}

	function logoutUser(){
		$rootScope.logged = false;
		Storage.clear();
		console.clear();
	}

}]);

'use strict';

angular.module('idea.main', ['ngRoute'])

        .config(['$routeProvider', function ($routeProvider) {
                $routeProvider.when('/main', {
                    templateUrl: 'app/main/main.html',
                    controller: 'mainCtrl'
                });
            }])

        .controller('mainCtrl', ['$routeParams', '$scope', 'Storage', 'ToolService', 'SendMail', function ($routeParams, $scope, Storage, ToolService, SendMail) {

                $scope.timeOut = $routeParams.timeOut;
                $scope.admin = Storage.isUserAdmin();
                $scope.user = Storage.getUser();

                $scope.userToolPromise = ToolService.User.save({}, function (data) {
                    $scope.toolUser = data;
                    $scope.toolStatus = toolCompleted($scope.toolUser);
                    sendMail($scope.user, $scope.toolStatus);
                })

                function toolCompleted(tools) {
                    $scope.toolCompleted = true;
                    for (var index in tools.tool) {
                        if (tools.tool[index].status != 'ended') {
                            $scope.toolCompleted = false;
                        }
                    }
                    return $scope.toolCompleted;
                }

                function sendMail(user, status) {
                    if (status == true) {
                        var idUser = user.id;
                        SendMail.Mail.save({id: idUser});
                    }
                }


              
            }]);

'use strict';

angular.module('idea.question', ['ngRoute'])

	.config(['$routeProvider', function ($routeProvider) {
		$routeProvider.when('/question', {
			templateUrl: 'app/question/question.html',
			controller: 'questionCtrl'
		});
	}])

	.controller('questionCtrl', ['$location', '$rootScope', '$routeParams', '$scope', '$timeout', '$window', 'Constants', 'CountdownService', 'QuizService', 'Storage', 'Timer', 'toaster', function($location, $rootScope, $routeParams, $scope, $timeout, $window, Constants, CountdownService, QuizService, Storage, Timer, toaster) {

		var user = Storage.getUser();
		var id = user.id;
		var code = user.code;

		$scope.idQuestion = $routeParams.idQuestion;
		$scope.idTool = $routeParams.idTool;
		$scope.idQuiz = $routeParams.idQuiz;
		$scope.downloadUrl = Constants.BASE_DOWNLOAD;
		$scope.answerText = {};
		$scope.choosedAnswer = {};
		$scope.saveAnswer = saveAnswer;
		$scope.saveAndClose = saveAndClose;
		$scope.showSaveButton = showSaveButton;

		$scope.questionPromise = QuizService.Question.save({idTool: $scope.idTool, idQuiz: $scope.idQuiz, idQuestion: $scope.idQuestion}).$promise
		.then(function(response){
			$scope.quizQuestion = response;
			$rootScope.$broadcast("QUESTION", response);
			return response;
		})
		.then(function(r){
			if(!_.isNull(r.timer) && !_.isUndefined(r.timer)){
				$timeout(function(){
					Timer.start(r.timer.now, r.timer.countdown, {idTool: $scope.idTool});
				}, 10)
			}
		});

		function sendAnswerToApi(answer){
			return QuizService.Save.save(answer).$promise
		}

		function closeQuiz(){
			return QuizService.Close.save({idTool: $scope.idTool, idQuiz: $scope.idQuiz}).$promise
		}

		function saveAndClose(opts){
			console.log("Save and close...");
			var userAnswer = extractAnswer(opts);
			sendAnswerToApi(userAnswer)
			.then(function(r){
				if(r.valid){
					return closeQuiz();
				}else{
					showSavingError();
					return false;
				}
			})
			.then(function(r){
					r.valid? navigateToSection($scope.idTool) : showClosingError();
			})
		}



		function saveAnswer(opts) {
                    if ($scope.quizQuestion.limit === extractAnswer(opts).answer.length || $scope.quizQuestion.limit === 0 || $scope.quizQuestion.limit == $scope.quizQuestion.answer.length) {
                        var userAnswer = extractAnswer(opts);
                        sendAnswerToApi(userAnswer)
                                .then(function (response) {
                                    if (response.valid) {
                                        showSavingSuccess();
                                        console.log("idQuestionSucc: " + response.idQuestionSucc);
                                        goToNextQuestion($scope.idTool, $scope.idQuiz, $scope.quizQuestion, response.idQuestionSucc);
                                    } else {
                                        showSavingError();
                                    }
                                });
                    } else {
                        risposteMancanti($scope.quizQuestion.limit - extractAnswer(opts).answer.length);
                    }
                }

		function extractAnswer(opts) {
			var result = {idTool: $scope.idTool, idQuiz: $scope.idQuiz, idQuestion: $scope.quizQuestion.idQuestion, answer: [], text: "", noAnswering:false};

			if(opts.noAnswering){
				result.noAnswering = true;
			}else{
				switch ($scope.quizQuestion.type) {
					case "checkbox":
						result.answer = _.chain($scope.quizQuestion.answer).filter(function (a) { return a.choosed })
							.map(function (a) { return a.id })
							.value();
						break;
					case "quickradiohor":
					case "quickradio":
					case "radio":
						result.answer = [$scope.choosedAnswer.radioChoosedId];
						break;
					case "text":
						result.answer = _.map($scope.quizQuestion.answer, function (a) { return a.id });
						result.text = $scope.answerText.text;
						break;
					case "drag":
						result.answer = _.map($scope.quizQuestion.answer, function (a) { return a.id });
						break;
					case "number":
						result.answer = _.map($scope.quizQuestion.answer, function (a) { return a.id });
						result.text = $scope.answerText.text;
						break;
					case "date":
						result.answer = _.map($scope.quizQuestion.answer, function (a) { return a.id });
						result.text = $scope.answerText.text;
						break;
					case "select":
						var selOpt = $scope.choosedAnswer.choosedOption;
						result.answer = selOpt ? [selOpt.id] : [];
						break;
					case "selectExtra":
						result.answer = [$scope.quizQuestion.answer];
						result.text = $scope.quizQuestion.extraAnswer;
						break;
					case "radiogroup":
						result.answer = [$scope.quizQuestion.answer];
						break;
					case 'multiple':
						console.log("Answers");
						console.dir($scope.quizQuestion.components);
						result.answers = _.chain($scope.quizQuestion.components)
							.map(function(a){ return {id: a.id, answer: a.answer}})
							.value();
						break;
					case 'couple':
						result.answer = $scope.quizQuestion.answer;
				}
			}
			return result;
		}


		function goToNextQuestion(idTool, idQuiz, question, conditionalIdQuestionSucc){

			if(conditionalIdQuestionSucc !== 0 && conditionalIdQuestionSucc !== null){
                            navigateToQuestion(idTool, idQuiz, conditionalIdQuestionSucc);
			} else if (question.idQuestionSucc !== 0 && question.idQuestionSucc !== null){
                            navigateToQuestion(idTool, idQuiz, question.idQuestionSucc);
			}else{
                            navigateToSummary(idTool, idQuiz);
                        }
                    }

		function navigateToQuestion(idTool, idQuiz, idQuestion){
				$location.path("/question").search({idTool: idTool, idQuiz: idQuiz, idQuestion: idQuestion});
		}

		function navigateToSummary(idTool, idQuiz){
				$location.path("/summary").search({idTool: idTool, idQuiz: idQuiz});
		}

		function navigateToSection(idTool){
				$location.path("/tool_detail").search({idTool: idTool});
		}

		function showSaveButton(question){
			if (_.isUndefined(question)){
				return false;
			}
			var questionTypesWithNoSaveButton = ['quickradio', 'quickradiohor', 'couple'];
			return ! _.contains(questionTypesWithNoSaveButton, question.type) || coupleQuestionWithAnswers(question);
		}

		function coupleQuestionWithAnswers(question){

			if (question.type != 'couple'){
				return false;
			}
			

			function haveAnswer(elements){
				return _.chain(elements).some(function(e){return e.choosed}).value();
			}

			var answerInPart1 = haveAnswer(question.part1.answers);
			var answerInPart2 = haveAnswer(question.part2.answers);
			return answerInPart1 && answerInPart2;
		}

		function showSavingError(){
					toaster.pop('error', "Errore", "Non è stato possibile salvare la risposta. Riprovare, se l'errore persiste contattare l'assistenza. Error:  " + data.error, 3000, 'trustedHtml');
		}

		function showSavingSuccess(){
					toaster.pop('success', "OK", "Risposta salvata correttamente.", 3000, 'trustedHtml');
		}
		function risposteMancanti(risposteCheMancano){
					toaster.pop('error', "Mancano delle risposte", "Selezionane ancora " + risposteCheMancano + " per poter proseguire", 3000, 'trustedHtml');
		}

		function showClosingError(){
					toaster.pop('error', "Errore", "Non è stato possibile chiudere il questionario. Riprovare, se l'errore persiste contattare l'assistenza. Error:  " + data.error, 3000, 'trustedHtml');
		}
	}]);

'use strict';

angular.module('idea.section_example', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
	$routeProvider.when('/section_example', {
		templateUrl: 'app/section_example/section_example.html',
		controller: 'section_exampleCtrl'
	});
}])

.controller('section_exampleCtrl', ['$location', '$routeParams', '$scope', 'Storage', 'ToolService', function($location, $routeParams, $scope, Storage, ToolService) {

	$scope.idTool = $routeParams.idTool;
	$scope.idQuiz = $routeParams.idQuiz;
	$scope.idQuestion = $routeParams.idQuestion;

	$scope.toolInstructionsPromise = ToolService.Detail.save({idTool: $scope.idTool}).$promise
		.then(function(r){
			$scope.resp = _.chain(r.quiz).find(function(q){return q.id == $scope.idQuiz}).value();
		});

}]);

'use strict';

angular.module('idea.section_instructions', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
	$routeProvider.when('/section_instructions', {
		templateUrl: 'app/section_instructions/section_instructions.html',
		controller: 'section_instructionsCtrl'
	});
}])

.controller('section_instructionsCtrl', ['$location', '$routeParams', '$scope', 'Storage', 'ToolService', function($location, $routeParams, $scope, Storage, ToolService) {

	$scope.idTool = $routeParams.idTool;
	$scope.idQuiz = $routeParams.idQuiz;
	$scope.idQuestion = $routeParams.idQuestion;

	$scope.toolInstructionsPromise = ToolService.Detail.save({idTool: $scope.idTool}).$promise
		.then(function(r){
			$scope.resp = _.chain(r.quiz).find(function(q){return q.id == $scope.idQuiz}).value();
		});

}]);

'use strict';

angular.module('idea.show_image', ['ngRoute'])

        .config(['$routeProvider', function ($routeProvider) {
                $routeProvider.when('/show_image', {
                    templateUrl: 'app/show_image/show_image.html',
                    controller: 'show_imageCtrl'
                });
            }])

        .controller('show_imageCtrl', ['$rootScope', '$routeParams', '$scope', 'Constants', 'UploadInfoService', function($rootScope, $routeParams, $scope, Constants, UploadInfoService) {


                $scope.imageId = $routeParams.image;
		$scope.uploadData = UploadInfoService.Data.get({id:$scope.imageId});
		$scope.downloadUrl = Constants.BASE_DOWNLOAD+$scope.imageId;

		$scope.goBack = function(){
			history.back();
		}

            }]);

'use strict';

angular.module('idea.summary', ['ngRoute'])

.config(['$routeProvider', function($routeProvider) {
	$routeProvider.when('/summary', {
		templateUrl: 'app/summary/summary.html',
		controller: 'summaryCtrl'
	});
}])

.controller('summaryCtrl', ['$location', '$routeParams', '$scope', 'QuizService', 'toaster', function($location, $routeParams, $scope, QuizService, toaster) {

	$scope.idOriginalQuestion = $routeParams.idQuestion;
	$scope.idTool = $routeParams.idTool;
	$scope.idQuiz = $routeParams.idQuiz;
	$scope.showSummary = true;
	$scope.close;


	$scope.summaryPromise = QuizService.Summary.save({idTool: $scope.idTool, idQuiz: $scope.idQuiz}).$promise
	.then(function(r){
		$scope.summary = r;
		$scope.close = closeQuiz;
	})
	.then(showButtons);


	function closeQuiz(){
		$scope.showSummary = false;
		QuizService.Close.save({idTool: $scope.idTool, idQuiz: $scope.idQuiz}).$promise
		.then(function(r){
			//Hack to close the modal overlay that remains open on page change
			$('.modal-backdrop').remove();
			$('body').removeClass('modal-open');
			if(r.valid){
				$location.path("/tool_detail").search({idTool: $scope.idTool, closed: 'true'});
			}else{
				toaster.pop('error', "Errore", "Non è stato possibile chiudere il questionario", 3000, 'trustedHtml');
			}
		});
	}

	function showButtons(){
		$scope.showClose = true;
	}

}]);

'use strict';

angular.module('idea.tool_detail', ['ngRoute'])

        .config(['$routeProvider', function ($routeProvider) {
                $routeProvider.when('/tool_detail', {
                    templateUrl: 'app/tool_detail/tool_detail.html',
                    controller: 'tool_detailCtrl'
                });
            }])

        .controller('tool_detailCtrl', ['$routeParams', '$scope', 'ToolService', function ($routeParams, $scope, ToolService) {

                $scope.idTool = $routeParams.idTool;
                $scope.closed = $routeParams.closed;
                $scope.timeout = $routeParams.timeout;
                $scope.toolDetailPromise = ToolService.Detail.save({idTool: $scope.idTool}).$promise
                        .then(function (data) {
                            $scope.detail = data;

                            $scope.r = data.tool;
                            $scope.rename = data.nameTool;
                            $scope.sectionsStatus = completedSection($scope.detail);
                        
                            function completedSection(sectionDetails) {
                                $scope.completed = true;
                                for (var quiz in sectionDetails.quiz) {
                                    if ($scope.completed && sectionDetails.quiz[quiz].completed == true) {
                                    } else {
                                        $scope.completed = false;
                                    }
                                }
                                return $scope.completed;
                            }
                            
                        }).then(function (data) {
                    $scope.toolDataReady = true;
                })

            }]);

angular.module("constants", [])

.constant("ApiLocation", "https://server.orientamento.tbg.ovh/api")

.constant("status", "production")

.constant("build", "5158")

.constant("commit", "81a3643ff52562756e9c9695bd9a564473439f92")

;

var app = angular.module('answers',[]);

app.directive('answers', [function(){
	return {
		restrict: 'EACM',
		templateUrl: 'app/components/directives/answers.html',
		replace: true,
		scope:{
			choosedAnswer: "=",
			answerText: "=",
			saveFunction: "&"
		},
		link: function (scope, elem, attrs) {

			var manage = function(question){
				scope.question = question;
				scope.answers = _.chain(question.answer)
				.filter(function(v){ return !v.noAnswering && !_.isEmpty(v.text)})
				.value();
				
				if (question.type === "radio"){
					scope.choosedAnswer.radioChoosedId = getSelected(question.answer);
					scope.$watch('choosedAnswer.radioChoosedId', function(value){
						_.each(scope.question.answer, function(a){
							a.choosed = (a.id === value);
						})

					});
				}

				if (question.type === "select"){
					scope.choosedAnswer.choosedOption = _.chain(scope.question.answer).findWhere({choosed: true}).value();
				}


				if (question.type === "text"){
					scope.answerText.text = _.first(scope.question.answer).text;
				}

				scope.chooseAnswerCheckbox = function(id){
					var clickedAnswer = _.find(scope.question.answer, function(a){
						return a.id === id;
					});

					var checkedAnswers = _.filter(scope.question.answer, function(a){
						return a.choosed;
					});

					if(clickedAnswer.choosed){
						clickedAnswer.choosed = !clickedAnswer.choosed;
						return;
					}

					if (!scope.question.limit || checkedAnswers.length < scope.question.limit){
						clickedAnswer.choosed = !clickedAnswer.choosed;
					}
				}

				scope.chooseAnswerRadio = saveAnswer;

				function saveAnswer (id){
					_.each(scope.question.answer, function(a){
						a.choosed = (a.id === id);
					})
					scope.choosedAnswer.radioChoosedId = id;
				}

				scope.chooseAnswerQuickRadio = function(id){
					console.log("QuickRadio: " + id);
					scope.choosedAnswer.radioChoosedId = id;
					scope.saveFunction();
				}

				scope.chooseAnswerCouple = function(id){
					console.log("Couple id: " + id);
				}

			}

			scope.checkboxLimit = function(id){

				if(_.isUndefined(scope.question.limit) || _.isNull(scope.question.limit)){
					return;;
				}

				var clickedAnswer = _.find(scope.question.answer, function(a){
					return a.id === id;
				});
				var checkedAnswers = _.filter(scope.question.answer, function(a){
					return a.choosed;
				});

				if (checkedAnswers.length > scope.question.limit){
					clickedAnswer.choosed = !clickedAnswer.choosed;
				}
			}


			function getSelected(answers){
				var answer =_.find(answers, function(a){return a.choosed});
				return _.isUndefined(answer)? null : answer.id;
			}


			scope.$on("QUESTION", function(event, question){
				console.log("Question");
				console.dir(question);
				manage(question);
			});
		}
	}}]);

var app = angular.module('countdown',[]);

app.directive('countdown', ['$location', '$timeout', 'Storage', function($location, $timeout, Storage){
	return{
		restrict: 'EACM',
		template: '<span style="font-weight:bold"></span>',
		replace: true,
		scope:{
		},
		link: function(scope, elem, attrs){

			function startAnimation(){
				function pulsate(){
					$(elem).animate({opacity: 0.2}, 1000, 'linear')
					.animate({opacity: 1}, 1000, 'linear', pulsate);
				}
				pulsate();
				Storage.setUltimiMinuti();
				scope.stile='ultimiMinuti';
				$timeout(function(){scope.$apply()});
			}

			function stopAnimation(){
				Storage.resetUltimiMinuti();
				$(elem).stop();
				$(elem).css({opacity:1});
			}

			function isAnimated(){
				return $(elem).is(":animated");
			}

			Storage.isUltimiMinuti() ? startAnimation() : stopAnimation();

			scope.$on('START_COUNTDOWN', function(event, opts){
				elem.countdown(opts.adjEnd, function(event){
					$(this).html(event.strftime('%I:%M:%S'));
				}).on('finish.countdown', function(event){
					console.log("Countdown raggiunto, redirect");
					$location.path('/tool_detail').search({idTool: opts.idTool, timeout: 'true'});
					$timeout(function(){scope.$apply()});
				}).on('update.countdown', function(event){
					var secondsLeft = event.offset.days * 86400 + event.offset.hours * 3600 + event.offset.minutes * 60 + event.offset.seconds;
					if(secondsLeft === 60){
						startAnimation();
					}
					if(isAnimated() && secondsLeft > 300){
						stopAnimation();
					}
				});
			});
		}
	}
}]);

var app = angular.module('imgvisible',[]);

app.directive('imgVisible', ['$http', function($http){
	return {
		restrict: 'EACM',
		templateUrl: 'app/components/directives/imgvisible.html',
		replace: true,
		scope:{
		},
		link: function (scope, elem, attrs) {
			scope.mostra=false;
			attrs.$observe('img', function(data){

				$http.get(data).success(function(v){
					scope.mostra=true;
					scope.percorso = data;
				});
			});
		}
	}}]);

var app = angular.module('ngreally', []);

app.directive('ngReally', [function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            element.bind('click', function() {
                var message = attrs.ngReallyMessage;
                if (message && confirm(message)) {
                    scope.$apply(attrs.ngReallyClick);
                }
            });
        }
    }
}]);

var app = angular.module('ptool', []);

app.directive('ptool', ['Constants', function(Constants) {
    return {
        restrict: 'EACM',
	templateUrl: 'app/components/directives/ptool.html',
	replace: true,
	scope:{
		attachment: "=",
		question: "@",
		tool: "@",
		size: "@"
	},
        link: function(scope, element, attrs) {
		scope.image=isImage(scope.attachment.type);
		scope.pdf=isPDF(scope.attachment.type);
		scope.thumbnail = thumbnailUrl(scope.size, scope.attachment.id);
		scope.downloadUrl = downloadUrl(scope.attachment.id);

		scope.$on("CHANGE_TUMBNAIL_SIZE", function(e, p){
			scope.thumbnail = thumbnailUrl(p, scope.attachment.id);
		});


		function downloadUrl(id){
			return Constants.BASE_DOWNLOAD+id;
		}
	

		function thumbnailUrl(size, id){
			return Constants.T+size+"/"+id;
		}

		function isImage(Attachmenttype){
			var result = false;
			var type= Attachmenttype.toUpperCase();
			switch(type){
				case "PNG" : result= true; break;
				case "JPG" : result= true; break;
				case "BMP" : result= true; break;
				case "GIF" : result= true; break;
			}
			return result;
		}

		function isPDF(Attachmenttype){
			return Attachmenttype.toUpperCase() == "PDF";
		}

		function isDOC(Attachmenttype){
			return Attachmenttype.toUpperCase() == "DOC";
		}
        }
    }
}]);

var app = angular.module('progressbar',[]);

app.directive('progressbar', [function(){
	return {
		restrict: 'A',
		replace: true,
		link: function (scope, elem, attrs) {

			function update(){
				percentage = Math.round(attrs.num / attrs.den * 100);
				elem.attr("aria-valuenow", percentage).css("width", percentage + "%");
			}

			scope.$watchGroup(['num', 'den'], function(newValues, oldValues, scope){
				update();
			});
		}
	}
}]);

var app = angular.module('readMore',[]);

app.directive('readMore', [function(){
	return{
		restrict: 'AE',
		templateUrl: 'components/directives/readMore.html',
		scope:{
			text : '@',
			limit : '@',
			fulltext:'@',
			moreText:'@',
			lessText:'@',
			moreClass:'@',
			lessClass:'@'
		},
		transclude: true,
		controller: function($scope){
			$scope.toggleValue = function(){
				$scope.fulltext = !$scope.fulltext;
			}
		}
	}
}]);

var app = angular.module('version',['constants']);

app.directive('version', ['build', 'commit', 'status', function(build, commit, status){
	return{
		restrict: 'E',
		replace: true,
		template: '<span>[{{version}}]</span>',
		scope:{},
		link: function(scope, elem, attrs){
			var hash = commit.substring(0,8);
			var type = (status == 'production') ? "P" : "D";
			scope.version = type+build+"-"+hash;
		}
	}
}]);

var app = angular.module('customFilters',[]);

app.filter('commaToNewLine', function(){
	return function(input){
		return input.replace(",", "\n");
	}
});

app.filter('textNotNull', [ function(){
	return function(elements){
		return _.chain(elements).filter(function(e){
			return e.text;
		}).value();
	}

}]);

'use strict'

var translations = angular.module('i18n', []);

translations.config(['$translateProvider', function ($translateProvider) {

	$translateProvider.useSanitizeValueStrategy('escape');
	//$translateProvider.useLocalStorage();


	$translateProvider
		.translations('en', lang_en)
		.translations('it', lang_it)
		.preferredLanguage('it');

	console.log("Translateprovider");
	console.dir($translateProvider);

    }]);

var lang_en = {
	language : 'language'
}

var lang_it = {
	language : 'lingua'
}

	var questionProgress = {
		bindings:{
			order: '<',
			total: '<'
		},
		templateUrl: 'app/components/questionProgress/questionProgress.html',
		controller: function(){
			var ctrl = this;
		}
	}

	angular
		.module('questionProgress')
		.component('questionProgress', questionProgress);

	var sectionSummary = {
		bindings:{
			summary: '<'
		},
		templateUrl: 'app/components/sectionSummary/sectionSummary.html'
	}

	angular
		.module('sectionSummary')
		.component('sectionSummary', sectionSummary);

var upload = angular.module('ImageService', [])

upload.factory('ImageService', ['Constants', function(Constants){
	return{

		getResizableToolLogoUrl: function(size, originalLogoUrl){

			if(_.isNull(originalLogoUrl) || _.isUndefined(originalLogoUrl) || _.isEmpty(originalLogoUrl)){
			return
			}

			function logoId(logoUrl){
				return logoUrl.match(/[0-9]+$/g)[0];
			}
			var logoId = logoId(originalLogoUrl);
			return Constants.L+size+"/"+logoId;
		},
		getResizableToolLogoWithId: function(size, logoId){

			if(!_.isNumber(logoId)){ return} 

			return Constants.L+size+"/"+logoId;
		}
	}
}]);

var resources = angular.module('randomservice', []);

resources.factory('RandomString', [function(){
	return{
	Rand: function (length) {
		var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
		var result = '';
		for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
		return result;
	}
	}
}]);

'use strict';

/* Services */

var resources = angular.module('idea.services', ['ngResource', 'constants', 'randomservice']);

resources.factory('Constants', ['ApiLocation', 'RandomString', function(ApiLocation, RandomString) {
	return  {BASE_URL: ApiLocation + "/"}
    }
]);


resources.factory('UserService', ['Constants', '$resource', function (C, $resource) {
        return {
            Login: $resource(C.BASE_URL + 'user/login', {}, {}),
            Connect: $resource(C.BASE_URL + 'user/connect', {}, {}),
            Password: $resource(C.BASE_URL + 'user/password', {}, {}),
            ResetPassword: $resource(C.BASE_URL + 'user/password/reset', {}, {}),
            ChangePass: $resource(C.BASE_URL + 'user/password/edit', {}, {}),
            Register: $resource(C.BASE_URL + 'user/register', {}, {}),
            Profile: $resource(C.BASE_URL + 'user/profile', {}, {}),
            UpdateProfile: $resource(C.BASE_URL + 'user/save/profile', {}, {})
        }
    }]);


resources.factory('ToolService', ['Constants', '$resource', function (C, $resource) {
        return {
            User: $resource(C.BASE_URL + 'tool/user', {}, {}),
            Detail: $resource(C.BASE_URL + 'tool/detail', {}, {}),
        }
    }]);

resources.factory('QuizService', ['Constants', '$resource', function (C, $resource) {
        return {
            Detail: $resource(C.BASE_URL + 'quiz/detail', {}, {}),
            Question: $resource(C.BASE_URL + 'quiz/question', {}, {}),
            Summary: $resource(C.BASE_URL + 'quiz/summary', {}, {}),
            Close: $resource(C.BASE_URL + 'quiz/close', {}, {}),
            Save: $resource(C.BASE_URL + 'quiz/save', {}, {})
        }
    }]);

resources.factory('CountdownService', ['Constants', '$resource', function (C, $resource) {
        return {
            Start: $resource(C.BASE_URL + 'quiz/timer', {}, {}),
            //Wait: $resource(C.BASE_URL + 'quiz/timer', {}, {}),
            //UpdateTimer: $resource(C.BASE_URL + 'quiz/timer', {}, {})
        }
    }]);

resources.factory('UploadInfoService', ['Constants', '$resource', function (C, $resource) {
        return {
            Info: $resource(C.BASE_URL + 'upload/info', {}, {}),
            Edit: $resource(C.BASE_URL + 'upload/edit', {}, {}),
            Delete: $resource(C.BASE_URL + 'upload/delete', {}, {}),
	    Data: $resource(C.BASE_URL + 'attachment/:id', {id: '@id'}, {}),
        }
    }]);

resources.factory('SendMail', ['Constants', '$resource', function (C, $resource) {
        return {
           Mail:$resource(C.BASE_URL + 'mail/:id', {id:'@id'}, {'query': {method: 'GET', isArray: false }}),
        }
    }]);






var storage = angular.module('idea.storage', ['LocalStorageModule']);

storage.factory('Storage', ['localStorageService', function(localStorageService){
	return{
		isUserLogged: function(){
			return this.getUser() !== null;
		},
		isUserAdmin: function(){
			return this.getUser().admin;
		},
		saveUser: function(userData){
			localStorageService.add('idea_userData', userData);
		},
		getUser: function(){
			return localStorageService.get('idea_userData');
		},
		saveRedirectUrl: function(url){
			localStorageService.add('idea_redirect_url', url);
		},
		getRedirectUrl: function(){
			return localStorageService.get('idea_redirect_url');
		},
		setUltimiMinuti: function(){
			localStorageService.add('idea_ultimiMinuti', true);
		},
		resetUltimiMinuti: function(){
			localStorageService.remove('idea_ultimiMinuti');
		},
		isUltimiMinuti: function(){
			var status = localStorageService.get('idea_ultimiMinuti');
			return !(_.isNull(status) || _.isUndefined(status));
		},
		clear: function(){
			localStorageService.clearAll();
		}
	}
}]);

var timer = angular.module('timerservice', ['LocalStorageModule']);

timer.factory('Timer', ['$interval', '$q', '$rootScope', '$timeout', 'localStorageService', function($interval, $q, $rootScope, $timeout, localStorageService){
	return{
		getDelta: function(nowServer){
			var serverNow = Date.parse(nowServer);
			var delta= new Date().getTime() - serverNow;
			var result;
			return delta;
		},

		resetDelta: function(){
			localStorageService.remove("idea_delta");
		},

		calcuateAdjustedTime : function(delta, time){
			var adjTime = Date.parse(time);
			return adjTime + delta;
		},

		startStepTimeout: function(nowServer, step){
			this.removeStepAlreadyFired();
			var now = new Date();
			var delta = this.getDelta(nowServer);
			var stepParsed = Date.parse(step);
			var stepDuration= Math.abs(now - stepParsed - delta);
			this.saveStepData(nowServer, step, stepDuration);
			this.setStepTimeoutStarted();
			var that = this;
			$timeout(function(){
				$rootScope.$broadcast('STEP_END');
				that.removeStepTimeoutStarted();
				that.setStepAlreadyFired();
			}, stepDuration);
		},

		start: function(nowServer, end, opts){
			var delta = this.getDelta(nowServer);
			opts.adjEnd = this.calcuateAdjustedTime(delta, end);
			$rootScope.$broadcast('START_COUNTDOWN', opts);
			this.setTimerStarted();
		},


		saveStepData: function(nowServer, step, stepDuration){
			localStorageService.add('idea_stepData',
						{ nowServer: nowServer, step: step, stepDuration: stepDuration});
		},

		getStepData: function(){
			return localStorageService.get('idea_stepData');
		},

		saveAdjEnd: function(adjEndTime){
			localStorageService.add('idea_adjEndTime', adjEndTime);
		},

		getAdjEnd: function(){
			return localStorageService.get('idea_adjEndTime');
		},

		setTimerStarted: function(){
			localStorageService.add('idea_timerStarted', true);
		},

		setStepTimeoutStarted: function(){
			localStorageService.add('idea_stepTimeoutStarted', true);
		},

		removeStepAlreadyFired: function(){
			localStorageService.remove('idea_step_fired');
		},

		setStepAlreadyFired: function(){
				localStorageService.add("idea_step_fired", true);
		},

		removeStepTimeoutStarted: function(){
			localStorageService.remove('idea_stepTimeoutStarted');
		},

		stepTimeoutStarted: function(){
			var status = localStorageService.get('idea_stepTimeoutStarted');
			return !(_.isNull(status) || _.isUndefined(status));
		},

		alreadyStarted: function(){
			var timerStatus = localStorageService.get('idea_timerStarted');
			return !(_.isNull(timerStatus) || _.isUndefined(timerStatus));
		},

		restart: function(){
			var adjEnd = this.getAdjEnd();
			$rootScope.$broadcast('START_COUNTDOWN', adjEnd);
			this.setTimerStarted();
		},

		restartStepTimeout: function(){
			var d = this.getStepData();
			//console.log("Step data recuperata");
			//console.dir(d);
			this.startStepTimeout(d.nowServer, d.step);
		},

		/*updatePolling: function(seconds){
			var milliseconds = seconds * 1000;
			localStorageService.add('idea_updatePolling', seconds);
			var that = this;
			var checkForUpdate = function(){
				WaitService.UpdateTimer.save({}, function(data){
					if(data.valid && data.changed){
						that.start(data.now, data.countdown, data.step1);
					}
				});
			}
			var polling = $interval(checkForUpdate, milliseconds);
			$rootScope.timerPolling = polling;
		},*/
		
		restartPolling: function(){
			if(_.isUndefined ($rootScope.timerPolling)){
				var seconds = localStorageService.get('idea_updatePolling');
				this.updatePolling(seconds);
			}
		}

	}
}]);

var upload = angular.module('idea.upload', ['ngFileUpload'])

upload.factory('UploadService', ['Upload', 'Constants', function(Upload, Constants){
	return{
               sendToServer: function (files, idTool, idQuestion, idUtente, codeUtente, type, successFunction) {
                    if (files && files.length) {
                        for (var i = 0; i < files.length; i++) {
                            var file = files[i];
                            Upload.upload({
                                url: Constants.BASE_URL + 'upload',
                                fileFormDataName: 'resource',
                                fields: {
                                    idTool: idTool,
				    idQuestion: idQuestion,
				    id: idUtente,
				    code: codeUtente,
				    uploadType: type
                                },
                                file: file
                            }).progress(function (e) {
				    var percentage = parseInt(100.0 * e.loaded / e.total);
				    console.log("Percentage: " + percentage + "%" + e.config.file.name);
                            }).success(function (data, status, header, config) {
				    successFunction();
				    console.log('file ' + config.file.name + 'uploaded. Response: ' + data);
                            })
                        }
                    }
                }
	}
}]);

(function(){

	var couple = {
		bindings:{
			question: '=',
			saveFunction: '&'
		},
		templateUrl: 'app/components/questions/couple/couple.html',
		controller: 'coupleCtrl'
	}

	angular
		.module('question.couple')
		.component('couple', couple);
})();

(function (){

'use strict';

//** @ngInject */
function coupleCtrl(){

	this.$onInit = function(){
		var ctrl = this;

		//inizializzo i valori per choosedAnswers
		var choosedAnswers = {};

		var clickedSection = {};
		clickedSection.part1= false;
		clickedSection.part2= false;

		ctrl.chooseAnswerCouple = chooseAnswer;
		initializeWithPreviousAnswers();

		function getChoosedAnswerId(elements){
			var result = _.chain(elements).find(function(e){return e.choosed}).value();
			return result ? result.id : undefined;
		}

		function initializeWithPreviousAnswers(){
			ctrl.question.answer[0] = getChoosedAnswerId(ctrl.question.part1.answers);
			ctrl.question.answer[1] = getChoosedAnswerId(ctrl.question.part2.answers);
		}


		function chooseAnswer(part, id){
			
			// 1. Salvataggio click sulla sezione corrispondente
			clickedSection['part'+part] = true;

			// 2. Salvataggio id risposta selezionata in array da salvare
			ctrl.question.answer[part-1] = id;

			//Setting choosed sulla risposta selezionata per questioni grafiche
			var choosedElement = _.chain(ctrl.question['part' + part].answers)
			.each(function(e){e.choosed = false})
			.find(function(e){return e.id == id})
			.value();
			choosedElement.choosed = true;

		  	// 3. Recupero id della risposta per l'altra sezione, anche se undefined
			var otherSection = getOtherSection(part);
			var otherSectionChoosedAnswerId = getChoosedAnswerId(ctrl.question["part" + otherSection].answers);
			ctrl.question.answer[otherSection-1] = otherSectionChoosedAnswerId;

			// 5. Se altra sezione è stata cliccata salvo
			if(clickedSection.part1 && clickedSection.part2){
				ctrl.saveFunction();
			}
		}

		function getOtherSection(sect){
			switch(sect){
				case 1: return 2; break;
				case 2: return 1; break;
				default: console.log("Error cannot get other section"); break;
			}
		}
	}
}

angular
	.module('question.couple')
	.controller('coupleCtrl', coupleCtrl);
})();


(function(){

	var dragList = {
		bindings:{
			question: '='
		},
		templateUrl: 'app/components/questions/dragList/dragList.html'
	}


	angular
		.module('question.dragList')
		.component('dragList', dragList);

})();

(function(){

	var multiple = {
		bindings:{
			question: '='
		},
		templateUrl: 'app/components/questions/multiple/multiple.html'
	}


	angular
		.module('question.multiple')
		.component('multiple', multiple);

})();

(function(){

	var radioGroup = {
		bindings:{
			question: '='
		},
		controller: 'radioGroupCtrl',
		templateUrl: 'app/components/questions/radioGroup/radioGroup.html'
	}


	angular
		.module('question.radioGroup')
		.component('radioGroup', radioGroup);

})();

(function(){

'use strict';

//** @ngInject */
function radioGroupCtrl(){

	this.$onInit = function(){
		var ctrl = this;

		var str = ctrl.question.answer[0].text;

		var transf = _.chain(ctrl.question.answer)
			.filter(function(a){return !_.isNull(a.text) && !_.isUndefined(a.text)})
			.map(function(a){
				var components = a.text.split("-");
				return {
					group: components[0],
					text: components[1],
					choosed: a.choosed,
					id: a.id
				}
			})
			.groupBy(function(e){return e.group})
			.mapObject(function(val, key){
				return  {group:key, show:false, icon:"fa fa-caret-right", values: val}
			})
			.values()
			.value();

		var flatted = _.chain(transf).pluck('values').flatten().value();
		var choosedId = _.chain(flatted).find(function(v){return v.choosed}).value();

		ctrl.groups = transf;
		ctrl.highlightAnswer = highlightAnswer;
		ctrl.question.answer = choosedId? choosedId.id : undefined;
		ctrl.toggleGroup = toggleGroup;

		function toggleGroup(group){
			var group = _.chain(transf).find(function(g){ return g.group == group}).value();
			group.show = !group.show;
			group.icon = toggleIcon(group.icon);
		}

		function toggleIcon(icon){
			return icon == "fa fa-caret-right" ? "fa fa-caret-down" : "fa fa-caret-right";
		}

		function highlightAnswer (id){
			_.each(flatted, function(a){
				a.choosed = (a.id === id);
			})
			ctrl.question.answer = id;
		}
	}
}


angular
	.module('question.radioGroup')
	.controller('radioGroupCtrl', radioGroupCtrl);

})();

(function(){

	var selectExtra = {
		bindings:{
			question: '=',
			saveFunction: '&'
		},
		templateUrl: 'app/components/questions/selectExtra/selectExtra.html',
		controller: 'selectExtraCtrl'
	}

	angular
		.module('question.selectExtra')
		.component('selectExtra', selectExtra);
})();

(function (){

'use strict';

//** @ngInject */
function selectExtraCtrl(){

	this.$onInit = function(){
		var ctrl = this;
		ctrl.showExtra = false;

		ctrl.choosed = _.chain(ctrl.question.answers).findWhere({choosed: true}).value();

		if(ctrl.choosed){
			ctrl.showExtra = ctrl.choosed.extra;
			ctrl.question.extraAnswer = ctrl.question.answer[0].text;
			ctrl.question.answer = ctrl.choosed.id;
		}else{
			ctrl.question.noAnswering = true;
			ctrl.question.answer = [];
		}

		ctrl.changed = function(answer){
			console.log("Changed function");
			console.dir(answer);
			ctrl.showExtra = answer.extra;
			ctrl.question.answer = answer.id;
		}
	}
}

angular
	.module('question.selectExtra')
	.controller('selectExtraCtrl', selectExtraCtrl);
})();


(function(){

	var status = {
		bindings:{
			inverted: '<',
			status: '<',
			url: '@',
			urlParams: '<'
		},
		templateUrl: 'app/components/reusable/status/status.html',
		controller: 'statusCtrl'
	}


	angular
		.module('reusable.status')
		.component('status', status);

})();

(function (){
'use strict';

//** @ngInject */
function statusCtrl($httpParamSerializer){

	this.$onInit = function(){
		var ctrl = this;
		var params = $httpParamSerializer(ctrl.urlParams);
		ctrl.completeUrl = ctrl.url + "?" + params;
	}
}

angular
	.module('reusable.status')
	.controller('statusCtrl', statusCtrl);
})();


angular.module('idea').run(['$templateCache', function($templateCache) {$templateCache.put('app/connect/connect.html','<div class="row"><div class="col-md-6 col-md-offset-3"><div class="well"><div class="txtCentrato"><h4>Accesso alla applicazione in corso...</h4><h2><i class="fa fa-cog fa-spin fa-3x fa-fw"></i></h2></div><br></div></div></div>');
$templateCache.put('app/help/help.html','<div class="panel panel-default"><div class="row"><div class="col-md-12"><h4>Help page</h4></div></div></div><br>');
$templateCache.put('app/login/login.html','<toaster-container></toaster-container><div class="row"><div ng-if="abilitazione"><div class="col-md-6 col-sm-6 col-md-offset-3 col-sm-offset-3"><div class="alert alert-success"><i class="fa fa-thumbs-o-up fa-2x" aria-hidden="true"></i> Il tuo account \xE8 abilitato ora puoi effettuare il login</div></div></div></div><svg id="bigTriangleCandy" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100" viewbox="0 0 100 100" preserveaspectratio="none" style="fill:#ffffff;padding:0;"><path d="M-1 -1 L50 99 L101 -1 Z"></path></svg><div class="row"><div class="col-md-4"><div class="well"><form ng-submit="enter()" class="form-signin formLogin" style=""><h4 class="form-signin-heading pull-right color-black"><strong>LOGIN</strong></h4><br><input type="email" class="form-control col-md-12" id="username" ng-model="username" placeholder="Email"> <input type="password" class="form-control col-md-12" ng-model="password" id="password" placeholder="Password"> <button class="btn btn-lg btn-orange btn-block color-white" type="submit" ng-click="login()">Accedi</button></form></div></div><div class="col-md-8"><h1 class="title">SCELTE GIUSTE PER IL FUTURO PROSSIMO</h1><br><p>Questionario di orientamento alla scelta scolastico-professionale per i giovani.</p><p>The European House - Ambrosetti da pi\xF9 di 50 anni affianca e sostiene le persone nei processi di cambiamento, di crescita e di sviluppo. The European House - Ambrosetti ricopre un ruolo di primo piano nel sistema educativo, creando un collegamento tra il mondo della ricerca e la consulenza a sostegno delle persone.</p><br><p>\xC8 possibile compilare il questionario da qualsiasi dispositivo: PC, Tablet e Smartphone.</p></div></div>');
$templateCache.put('app/logout/logout.html','<div class="row"><div class="col-md-6 col-md-offset-3"><div class="well"><h4>Hai completato con successo il logout dall\'applicazione.</h4><h4>Puoi rientrare sulla <a href="index.html#!/login">pagina di login.<br></a></h4></div></div></div>');
$templateCache.put('app/main/main.html','<div class="row"><div class="col-md-12"><h2 class="title">Scelte giuste per il futuro prossimo</h2></div></div><div class="row"><div class="col-md-12"><p>Benvenuto nella sessione on-line del questionario <i>Scelte giuste per il futuro prossimo</i>!</p><p>Le diverse prove previste ti aiuteranno a comprendere le tue caratteristiche e gli interessi scolastico-professionali per fare una scelta consapevole e di successo per il tuo percorso di studi.</p><p>Quanto emerger\xE0 dal questionario sar\xE0 trattato in modo riservato e non verr\xE0 comunicato ad altri. Per motivi di riservatezza ad ogni accesso per la compilazione ti verranno richieste Username e Password.</p><p>Al termine della compilazione riceverai un report personalizzato sul lavoro effettuato. Ricorda di prenotare la tua sessione di discussione con un esperto The European House - Ambrosetti!</p><p>La compilazione del questionario prevede un tempo complessivo di <b>circa 2 ore.</b><br>Assicurati di avere uno spazio idoneo per la compilazione senza distrazioni o interferenze. &Egrave; possibile interrompere la compilazione e riprenderla successivamente.</p><p><b>Attenzione:</b> alcune prove sono a tempo. Una volta trascorso, la prova si concluder\xE0 automaticamente e non sar\xE0 ulteriormente possibile riprendere la compilazione degli item mancanti.</p><p>Il questionario \xE8 composto da <b>4 sezioni, ciascuna di esse contenente 3 o 5 prove.</b> Le sezioni sono:</p></div></div><br><div cg-busy="userToolPromise"></div><div class="row"><div class="col-md-9"><div class="well"><div class="row" ng-repeat="toolUser in toolUser.tool"><div class="col-md-7"><strong><span class="glyphicon glyphicon-chevron-right textArancione" aria-hidden="true"></span> &nbsp; {{toolUser.name}}</strong></div><div class="col-md-1"><status inverted="true" url="#!/tool_detail" url-params="{idTool: toolUser.id}" status="toolUser.status"></status></div><br><br><br></div></div></div><div class="col-md-3" ng-if="toolStatus"><div class="well terminatoQuestionario"><p>Complimenti, hai completato l\'intero questionario!</p><br><p>Sarai contattato nei prossimi giorni dai consulenti The European House - Ambrosetti per prenotare la tua sessione di restituzione del report.</p><br><br><br><br></div></div></div><br>');
$templateCache.put('app/question/question.html','<toaster-container></toaster-container><br><div class="row questionNav"><div class="col-md-2 col-xs-3"><div ng-if="quizQuestion.timer" class="color-black"><p><span class="hidden-xs">Tempo rimanente</span><countdown></countdown></p></div><div ng-if="!quizQuestion.timer"><a title="Indietro all\'inizio della sezione" href="#!/tool_detail?idTool={{idTool}}"><i class="fa fa-caret-left"></i> <span class="hidden-xs">Inizio sezione</span></a></div></div><div class="col-md-2 col-xs-2"><a title="Indietro all\'inizio della sezione" href="#!/section_instructions?idTool={{idTool}}&idQuiz={{idQuiz}}&idQuestion={{idQuestion}}"><i class="fa fa-question-circle" aria-hidden="true"></i> <span class="hidden-xs">Istruzioni</span></a></div><div class="col-md-4 col-xs-3"><question-progress order="quizQuestion.order" total="quizQuestion.total"></question-progress></div><div class="col-md-3 col-md-offset-1 col-xs-4"><a class="pull-right" title="Pagina di riepilogo delle domande" ng-href="#!/summary?idTool={{idTool}}&idQuiz={{quizQuestion.idQuiz}}&idQuestion={{idQuestion}}"><span class="glyphicon glyphicon-th" aria-hidden="true"></span> <span class="hidden-xs">Domande del questionario</span></a></div></div><hr><div class="row"><div cg-busy="questionPromise"></div><p class="pull-right"><span class="glyphicon glyphicon-chevron-right textArancione" aria-hidden="true"></span> {{quizQuestion.name}}</p><div class="col-md-12 text20 marginTop_10"><p ng-if="quizQuestion.text" class="small startSection marginbott5per item"><span ng-bind-html="quizQuestion.text"></span></p><p ng-if="quizQuestion.description"><b class="item" ng-bind-html="quizQuestion.description"></b></p><p ng-if="quizQuestion.text2" class="small startSection marginbott5per item"><span ng-bind-html="quizQuestion.text2"></span></p></div></div><br><div class="well col-md-12"><span ng-show="!noAnswering" class=""><answers answer-text="answerText" choosed-answer="choosedAnswer" save-function="saveAnswer({})"></answers></span></div><br><div class="row"><div class="col-md-5 col-sm-5 col-xs-2" ng-cloack="" ng-if="quizQuestion.idQuestionPrev != 0"><a class="btn btn-orange color-white" ng-href="#!/question?idTool={{idTool}}&idQuiz={{idQuiz}}&idQuestion={{quizQuestion.idQuestionPrev}}" role="button"><i class="fa fa-caret-left"></i> Indietro</a></div><div class="col-md-5 col-sm-5 col-xs-2" ng-cloack="" ng-if="quizQuestion.idQuestionPrev == 0"><a title="Indietro all\'inizio della sezione" href="#!/tool_detail?idTool={{idTool}}"><i class="fa fa-caret-left"></i> <span class="hidden-xs">Inizio sezione</span></a></div><div class="col-md-7 col-sm-4 col-xs-2 col-xs-offset-8 col-lg-offset-0 col-md-offset-0"><div ng-if="showSaveButton(quizQuestion)"><button ng-disabled="checkIfAnswered()" class="btn btn-orange color-white pull-right" type="submit" ng-click="saveAnswer({})"><span class="hidden-xs">Avanti</span> <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span></button></div></div></div><div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"><div class="modal-dialog"><div class="modal-content"><div class="row padding20"><div class="col-md-10"><div class="col-md-11 col-md-offset-1"><h2>Description</h2>{{quizQuestion.description}}</div></div></div></div></div></div><br>');
$templateCache.put('app/section_example/section_example.html','<div cg-busy="toolInstructionsPromise"></div><div class="row"><div class="col-md-12"><h2 class="title">{{resp.name}}<br><small>Esempi</small></h2></div></div><div class="row"><div class="col-md-12"><div ng-bind-html="resp.descriptionExample"></div><br></div></div><br><br><div class="row"><div class="col-md-2 pull-left"><a class="btn btn-orange color-white" ng-href="#!/tool_detail?idTool={{idTool}}" role="button"><i class="fa fa-caret-left"></i> Indietro</a></div></div>');
$templateCache.put('app/section_instructions/section_instructions.html','<div cg-busy="toolInstructionsPromise"></div><div class="row"><div class="col-md-12"><h2 class="titleNoMarginBott">{{resp.name}}<br><small>Istruzioni per la compilazione</small></h2></div></div><div class="row"><div class="col-md-12"><div ng-bind-html="resp.description"></div></div></div><br><br><div class="row"><div class="col-md-2 pull-left"><a class="btn btn-orange color-white" ng-href="#!/tool_detail?idTool={{idTool}}" role="button"><i class="fa fa-caret-left"></i> Indietro</a></div><div class="col-xs-1 col-md-1 col-sm-2 col-lg-2 pull-right"><a class="btn btn-orange color-white pull-right" ng-href="#!/question?idTool={{idTool}}&idQuiz={{idQuiz}}&idQuestion={{idQuestion}}" role="button">Inizia la compilazione</a></div></div>');
$templateCache.put('app/show_image/show_image.html','<toaster-container></toaster-container><div><div class="row well wellQuestion"><a class="btn btn-default" ng-click="goBack()"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>Back</a> <a class="btn btn-success pull-right" ng-href="{{downloadUrl}}"><i class="fa fa-download" aria-hidden="true"></i> Download full resolution image</a></div><div class="row well wellQuestion"><img class="fullImage center-block" ng-src="{{downloadUrl}}" alt=""></div><div class="row well wellQuestion"><ul><li><strong>Name:</strong> {{uploadData.name}}</li><li><strong>Description:</strong> {{uploadData.description}}</li><li><strong>Category:</strong> {{uploadData.category}}</li></ul></div></div>');
$templateCache.put('app/summary/summary.html','<toaster-container></toaster-container><div class="row"><div class="col-md-12"><h2 class="title">Domande del questionario</h2></div></div><div class="row"><div class="col-md-12"><p>In basso sono riportate le domande della sessione in corso e lo stato di compilazione.</p><p>Nel caso in cui tu abbia saltato qualche risposta o voglia modificarne qualcuna gi\xE0 data, puoi cliccare sul riquadro corrispondente.</p><br><h5>Legenda:</h5><br><ul class="legenda"><li><button class="btn btn-xs btn-completed"><i class="fa fa-check-circle-o" aria-hidden="true"></i></button> Domanda per la quale la risposta \xE8 stata salvata correttamente</li><li><button class="btn btn-xs btn-info"><i class="fa fa-question-circle-o" aria-hidden="true"></i></button> Domanda che \xE8 stata saltata</li><li><button class="btn btn-xs btn-default"><i class="fa fa-circle-o" aria-hidden="true"></i></button> Domanda non ancora visualizzata</li></ul></div></div><br><div cg-busy="summaryPromise"></div><div class="row" ng-if="summary.notAnswerAll"><div class="questionNav"><div class="col-md-8 col-md-offset-2 alert alert-danger">Attenzione, non hai risposto a tutte le domande. Clicca sui riquadri qui sotto per completare tutte le domande.</div></div><br></div><div class="row"><div class="col-md-5 col-xs-4"><div ng-if="!idOriginalQuestion"><a ng-href="#!/tool_detail?idTool={{idTool}}"><i class="fa fa-caret-left"></i> <span class="hidden-xs">Indietro</span></a></div><div ng-if="idOriginalQuestion"><a class="btn btn-orange color-white" ng-href="#!/question?idTool={{idTool}}&idQuiz={{idQuiz}}&idQuestion={{idOriginalQuestion}}" role="button"><i class="fa fa-caret-left"></i> Indietro</a></div></div><div class="col-md-2 col-xs-2"><button ng-if="showClose" type="button" class="btn btn-warning pull-right" data-toggle="modal" data-target="#chiusuraModal"><i class="fa fa-floppy-o" aria-hidden="true"></i> <span class="hidden-xs">Salva e chiudi</span></button></div><div class="col-md-5 col-xs-3"><div class="questionNav"><a class="pull-right" title="Indietro all\'inizio della sezione" href="#!/tool_detail?idTool={{idTool}}"><i class="fa fa-caret-left"></i> Inizio sezione</a></div></div></div><br><div class="row"><div class="col-md-12"><div class="well"><section-summary summary="summary"></section-summary></div></div></div><div class="modal fade" tabindex="-1" role="dialog" id="chiusuraModal"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Conferma chiusura della sessione</h4></div><div class="modal-body"><p>Sei sicuro di voler chiudere questa sessione?</p><p><strong>Premendo il tasto "salva e chiudi" tutte le risposte inserite saranno confermate e non pi\xF9 modificabili.</strong></p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Annulla</button> <button type="button" class="btn btn-warning" ng-click="close()"><i class="fa fa-floppy-o" aria-hidden="true"></i> Salva e chiudi</button></div></div></div></div>');
$templateCache.put('app/templates/loading.html','<div class="cg-busy-default-wrapper"><div class="cg-busy-default-sign loadingContainer"><i class="fa fa-cog fa-spin fa-2x fa-fw"></i><div class="cg-busy-default-text"><h5>{{$message}}</h5></div></div></div>');
$templateCache.put('app/tool_detail/tool_detail.html','<toaster-container></toaster-container><div class="row"><div class="col-md-12"><div class="alert alert-warning" ng-if="timeout"><button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button><p><i class="fa fa-clock-o fa-2x" aria-hidden="true"></i> <strong>ATTENZIONE:</strong> Il tempo che avevi a disposizione per concludere il questionario \xE8 terminato, ogni risposta inserita \xE8 stata correttamente salvata. Puoi proseguire con la compilazione degli altri questionari, se presenti.</p></div></div></div><div class="row"><div class="col-md-12"><h2 class="title">{{detail.tool.name}}</h2></div></div><div class="row"><div class="col-md-12" ng-bind-html="detail.tool.detailed"></div></div><br><div class="row"><div class="col-md-12"><div class="well"><div class="row" ng-repeat="quiz in detail.quiz"><div class="col-md-3" ng-if="quiz.example"><strong><span class="glyphicon glyphicon-chevron-right textArancione" aria-hidden="true"></span> &nbsp; {{quiz.name}}</strong></div><div class="col-md-5" ng-if="!quiz.example"><strong><span class="glyphicon glyphicon-chevron-right textArancione" aria-hidden="true"></span> &nbsp; {{quiz.name}}</strong></div><div class="col-md-2" ng-if="quiz.example"><div><a class="btn btn-block btn-orange color-white" ng-href="#!/section_example?idTool={{idTool}}&idQuiz={{quiz.id}}&idQuestion={{quiz.firstQuestion}}" role="button"><span>Esempi</span></a></div></div><div class="col-md-3"><div class="progress hidden-xs"><div class="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" num="{{quiz.answer}}" den="{{quiz.totQuestions}}" progressbar="">{{(quiz.answer / quiz.totQuestions) * 100 | number: 1}}%</div></div></div><div class="col-md-1"><span ng-if="quiz.withTimer"><i class="fa fa-clock-o" aria-hidden="true"></i> <span>{{quiz.minutes}}m</span></span></div><div class="col-md-3"><div ng-cloak="" ng-if="!quiz.completed"><a class="btn btn-block btn-orange color-white" ng-href="#!/section_instructions?idTool={{idTool}}&idQuiz={{quiz.id}}&idQuestion={{quiz.firstQuestion}}" role="button"><span ng-if="quiz.withTimer"><i class="fa fa-clock-o" aria-hidden="true"></i></span> <span ng-if="!quiz.withTimer">&nbsp;&nbsp;</span> <span>Inizia la compilazione</span></a></div><div ng-cloak="" ng-if="quiz.completed"><button disabled="" class="btn color-white"><span>Completato</span></button></div></div></div></div></div></div><div class="row"><div class="col-md-6"><a class="btn btn-orange color-white" ng-href="index.html#!/main" role="button"><i class="fa fa-caret-left"></i> Indietro</a></div><div class="col-md-6" ng-if="sectionsStatus"><a class="btn btn-orange color-white pull-right" ng-href="index.html#!/main" role="button">Avanti <i class="fa fa-caret-right"></i></a></div></div>');
$templateCache.put('app/components/directives/answers.html','<div class="row col-md-12"><div ng-if="question.type === \'checkbox\'"><table class="table question"><tr ng-class="{info: answer.choosed}" ng-repeat="answer in answers"><td class="choose"><input ng-model="answer.choosed" type="checkbox" ng-click="checkboxLimit(answer.id)"></td><td><a title="" ng-attr-title="{{answer.suggestion}}" class="answer" href="" ng-click="chooseAnswerCheckbox(answer.id)">{{answer.text}}</a></td></tr></table></div><div ng-if="question.type === \'radio\'"><table class="table question"><tr ng-class="{info: answer.choosed}" ng-repeat="answer in answers"><td class="choose"><input ng-model="choosedAnswer.radioChoosedId" type="radio" name="choose" ng-value="answer.id"></td><td><a class="answer" href="" ng-click="chooseAnswerRadio(answer.id)">{{answer.text}}</a></td></tr></table></div><div ng-if="question.type === \'quickradio\'"><a ng-repeat="answer in answers" ng-class="{\'selected\': answer.choosed}" class="btn btn-text-wrap btn-default btn-lg btn-block" href="" ng-click="chooseAnswerQuickRadio(answer.id)">{{answer.text}}</a></div><div ng-if="question.type === \'quickradiohor\'"><div class="row"><div class="hidden-xs col-lg-11 col-md-11 col-sm-11"><img src="../assets/img/scala10b.png" class="img img-responsive hidden-xs"></div><div class="visible-xs-block col-xs-12"><img src="../assets/img/scala10m.png" class="img img-responsive"></div></div><div ng-repeat="answer in answers" class="col-lg-1 col-md-1 col-sm-1 col-xs-2"><a class="btn btn-default btn-lg" href="" ng-class="{\'btn-info\': answer.choosed}" ng-click="chooseAnswerQuickRadio(answer.id)">{{answer.text}}</a></div></div><div ng-if="question.type === \'text\'"><div class="form-group"><textarea autofocus="" maxlength="3000" class="form-control" id="answerText" ng-model="answerText.text" placeholder="Scrivi qui la tua risposta..." cols="30" rows="12"></textarea> <small>Per espandere, trascinare l\'angolo destro</small> <small class="pull-right">{{3000 - answerText.text.length}} caratteri a disposizione</small></div></div><div ng-if="question.type === \'drag\'"><drag-list question="question"></drag-list></div><div ng-if="question.type === \'multiple\'"><multiple question="question"></multiple></div><div ng-if="question.type === \'couple\'"><couple question="question" save-function="saveFunction()"></couple></div><div ng-if="question.type === \'selectExtra\'"><select-extra question="question" save-function="saveFunction()"></select-extra></div><div ng-if="question.type === \'radiogroup\'"><radio-group question="question" save-function="saveFunction()"></radio-group></div><div ng-if="question.type === \'number\'"><div class="row"><div class="col-md-4"><div class="form-group"><input type="number" class="form-control" ng-model="answerText.text" min="0" placeholder="Risposta in formato numerico"></div></div></div></div><div ng-if="question.type === \'date\'"><div class="form-group"><input type="date" class="form-control" ng-model="answerText.text" min="0"></div></div><div ng-if="question.type === \'select\'"><div class="form-group"><select class="form-control" id="select" ng-options="answer.text for answer in question.answer | textNotNull" ng-model="choosedAnswer.choosedOption"></select></div></div></div>');
$templateCache.put('app/components/directives/imgvisible.html','<img ng-show="mostra" src="{{percorso}}" alt="Img">');
$templateCache.put('app/components/directives/preview.html','<span><span ng-if="image"><a style="text-decoration:none" ng-href="#!/show_image?image={{attachment.id}}" title="Click to see the image in original size"><img ng-src="{{thumbnail}}"></a></span> <span ng-if="pdf"><a style="text-decoration:none" ng-href="{{downloadUrl}}" title="Click to download the document"><img width="{{size}}" src="img/pdf.png"></a></span> <span ng-if="doc"><a style="text-decoration:none" ng-href="{{downloadUrl}}" title="Click to download the document"><img width="{{size}}" src="img/doc.png"></a></span></span>');
$templateCache.put('app/components/directives/readMore.html','<span ng-if="text.length > limit"><span ng-hide="fulltext">{{ text | limitTo:limit }}... <a ngclass="{{ moreClass }}" ng-click="toggleValue()">{{ moreText }}</a></span> <span ng-show="fulltext">{{ text }} <a ng-class="{{ lessClass }}" ng-click="toggleValue()">{{ lessText }}</a></span></span> <span ng-if="text.length <= limit">{{ text }}</span>');
$templateCache.put('app/components/questionProgress/questionProgress.html','<span class="hidden-xs">Avanzamento:</span> {{$ctrl.order}} / {{$ctrl.total}}<div class="progress hidden-xs" style="height: 3px;"><div class="progress-bar" role="progressbar" aria-valuenow="{{$ctrl.order}}" aria-valuemin="1" aria-valuemax="{{$ctrl.total}}" style="min-width:4em; width: {{($ctrl.order / $ctrl.total) * 100}}%;"></div></div>');
$templateCache.put('app/components/sectionSummary/sectionSummary.html','<div class="btn-toolbar" role="toolbar"><div class="btn-group"><span ng-repeat="status in $ctrl.summary.statuses"><a ng-if="status.status==\'answered\'" ng-href="#!/question?idTool={{$ctrl.summary.idTool}}&idQuiz={{$ctrl.summary.idQuiz}}&idQuestion={{status.id}}" class="btn btn-completed btn-sm summary-button summary-selected" title="Hai risposto a questa domanda"><h4>{{status.order}}</h4><i class="fa fa-check-circle-o fa-2x" aria-hidden="true"></i></a> <a ng-if="status.status==\'pending\'" ng-href="#!/question?idTool={{$ctrl.summary.idTool}}&idQuiz={{$ctrl.summary.idQuiz}}&idQuestion={{status.id}}" class="btn btn-default btn-sm summary-button" title="Non hai ancora visualizzato questa domanda"><h4>{{status.order}}</h4><i class="fa fa-circle-o fa-2x" aria-hidden="true"></i></a> <a ng-if="status.status == \'skipped\'" ng-href="#!/question?idTool={{$ctrl.summary.idTool}}&idQuiz={{$ctrl.summary.idQuiz}}&idQuestion={{status.id}}" class="btn btn-info btn-sm summary-button" title="Hai saltato questa domanda"><h4>{{status.order}}</h4><i class="fa fa-question-circle-o fa-2x" aria-hidden="true"></i></a></span></div></div><br><style>\n.summary-button{\n\tmargin-left: 2px;\n\tmargin-top: 10px;\n\tz-index: 100;\n}\n</style>');
$templateCache.put('app/components/questions/couple/couple.html','<style>\n\n    .equal-container {\n        display: flex;\n    }\n\n    .col1 {\n        padding: 1em;\n        width: 50%;\n    }\n\n    .col2 {\n        padding: 1em;\n        width: 50%;\n    }\n\n    .list-group-full-height {\n        list-style-type: none;\n        margin: 0;\n        padding: 0;\n        display: table;\n        width: 100%;\n        height: 100%;\n    }\n\n\n    .list-order-item {\n        display: table-row;\n    }\n\n    .badge-big{\n        font-size: 140%;\n    }\n</style><div class="equal-container"><div class="col1 pull-left marginbott_zero"><h4 class="title colorItem marginbott_zero">{{$ctrl.question.part1.title}}</h4></div><div class="col2 pull-right marginbott_zero"><h4 class="title colorItem marginbott_zero">{{$ctrl.question.part2.title}}</h4></div></div><div class="equal-container"><div class="col1 pull-left"><a ng-repeat="answer in $ctrl.question.part1.answers" ng-class="{\'selected\': answer.choosed}" class="btn btn-text-wrap btn-default btn-lg btn-block" href="" ng-click="$ctrl.chooseAnswerCouple(1, answer.id)">{{answer.text}}</a></div><div class="col2 pull-right"><a ng-repeat="answer in $ctrl.question.part2.answers" ng-class="{\'selected\': answer.choosed}" class="btn btn-text-wrap btn-default btn-lg btn-block" href="" ng-click="$ctrl.chooseAnswerCouple(2, answer.id)">{{answer.text}}</a></div></div>');
$templateCache.put('app/components/questions/dragList/dragList.html','<style>\n\n.dragList ul[dnd-list] .dndDraggingSource {\n    display: none;\n}\n\n.dragList ul[dnd-list] .dndPlaceholder {\n    background-color: #ddd;\n    display: block;\n    min-height: 50px;\n}\n\n.dragList ul[dnd-list] li {\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-top-right-radius: 4px;\n    border-top-left-radius: 4px;\n    display: block;\n    padding: 10px 15px;\n    margin-bottom: -1px;\n}\n\n.equal-container {\n\tdisplay: flex;\n}\n\n.dragList-col1 {\n\tpadding: 1em;\n\twidth: 10%;\n}\n\n.dragList-col2 {\n\tpadding: 1em;\n\twidth: 90%;\n}\n\n.list-group-full-height {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    display: table;\n    width: 100%;\n    height: 100%;\n}\n\n\n.list-order-item {\n    display: table-row;\n}\n\n.badge-big{\n\tfont-size: 140%;\n}\n</style><div class="equal-container"><div class="dragList-col1"><ul class="list-group list-group-full-height"><li class="list-group-item list-order-item" ng-repeat="answer in $ctrl.question.answer"><br><span class="badge badge-big"><strong>{{$index + 1}}</strong></span><br></li></ul></div><div class="dragList-col2"><div class="dragList"><ul class="list-group" dnd-list="$ctrl.question.answer"><li class="list-group-item" ng-repeat="answer in $ctrl.question.answer" dnd-draggable="answer" dnd-moved="$ctrl.question.answer.splice($index, 1)" dnd-effect-allowed="move" dnd-selected="models.selected = item" ng-class="{\'selected\': models.selected == item}"><br><p>{{answer.text}}</p><br></li></ul></div></div></div>');
$templateCache.put('app/components/questions/multiple/multiple.html','<div class="form-group"><div ng-repeat="component in $ctrl.question.components"><label>{{component.text}}</label> <input class="form-control" type="{{component.type}}" ng-model="component.answer"><br></div></div>');
$templateCache.put('app/components/questions/radioGroup/radioGroup.html','<div ng-repeat="g in $ctrl.groups"><br><a href="" ng-click="$ctrl.toggleGroup(g.group)"><strong><i ng-class="g.icon"></i> {{g.group}}</strong></a><div ng-show="g.show"><table class="table question"><tr ng-class="{info: answer.choosed}" ng-repeat="answer in g.values"><td class="choose"><input ng-model="$ctrl.question.answer" type="radio" name="choose" ng-value="answer.id"></td><td><a class="answer" href="" ng-click="$ctrl.highlightAnswer(answer.id)">{{answer.text}}</a></td></tr></table></div></div>');
$templateCache.put('app/components/questions/selectExtra/selectExtra.html','<div><div class="form-group"><select class="form-control" id="select" ng-options="answer.text for answer in $ctrl.question.answers" ng-model="$ctrl.choosed" ng-change="$ctrl.changed($ctrl.choosed)"></select></div><div ng-if="$ctrl.showExtra" class="form-group"><label for="specifica">{{$ctrl.question.extraText}}</label> <input type="text" class="form-control" id="specifica" ng-model="$ctrl.question.extraAnswer"></div></div>');
$templateCache.put('app/components/reusable/status/status.html','<div><div ng-if="$ctrl.status == \'ready\' || !$ctrl.status"><a ng-class="{\'btn-primary-inverted\': $ctrl.inverted, \'btn-primary\': !$ctrl.inverted}" class="btn btn-orange color-white" ng-href="{{$ctrl.completeUrl}}" role="button">Entra nella sezione</a></div><div ng-if="$ctrl.status == \'paused\'"><a ng-class="{\'btn-primary-inverted\': $ctrl.inverted, \'btn-primary\': !$ctrl.inverted}" class="btn btn-orange color-white" ng-href="{{$ctrl.completeUrl}}" role="button">Continua</a></div><div ng-if="$ctrl.status == \'ended\'"><a class="btn btn-selected btn-completed color-white" disabled="disabled" ng-href="" role="button">Completato</a><div ng-if="$ctrl.status == \'disabled\'"><a class="btn btnLogin color-white" disabled="disabled" ng-href="" role="button">Entra nella sezione</a></div></div></div>');}]);